// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnnouncementModalController from "./announcement_modal_controller"
application.register("announcement-modal", AnnouncementModalController)

import ArticleController from "./article_controller"
application.register("article", ArticleController)

import ArticleImagesController from "./article_images_controller"
application.register("article-images", ArticleImagesController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import Bridge__AddToCalendarController from "./bridge/add_to_calendar_controller"
application.register("bridge--add-to-calendar", Bridge__AddToCalendarController)

import Bridge__AlertController from "./bridge/alert_controller"
application.register("bridge--alert", Bridge__AlertController)

import Bridge__AuthenticationController from "./bridge/authentication_controller"
application.register("bridge--authentication", Bridge__AuthenticationController)

import Bridge__ButtonController from "./bridge/button_controller"
application.register("bridge--button", Bridge__ButtonController)

import Bridge__DocumentScannerController from "./bridge/document_scanner_controller"
application.register("bridge--document-scanner", Bridge__DocumentScannerController)

import Bridge__FormController from "./bridge/form_controller"
application.register("bridge--form", Bridge__FormController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__NavigationContextController from "./bridge/navigation_context_controller"
application.register("bridge--navigation-context", Bridge__NavigationContextController)

import Bridge__NfcContactController from "./bridge/nfc_contact_controller"
application.register("bridge--nfc-contact", Bridge__NfcContactController)

import Bridge__NotificationTokenController from "./bridge/notification_token_controller"
application.register("bridge--notification-token", Bridge__NotificationTokenController)

import Bridge__PhotoPickerController from "./bridge/photo_picker_controller"
application.register("bridge--photo-picker", Bridge__PhotoPickerController)

import Bridge__SearchController from "./bridge/search_controller"
application.register("bridge--search", Bridge__SearchController)

import Bridge__ToastController from "./bridge/toast_controller"
application.register("bridge--toast", Bridge__ToastController)

import Bridge__UnauthenticationController from "./bridge/unauthentication_controller"
application.register("bridge--unauthentication", Bridge__UnauthenticationController)

import BusinessCardProcessingController from "./business_card_processing_controller"
application.register("business-card-processing", BusinessCardProcessingController)

import CacheRefreshController from "./cache_refresh_controller"
application.register("cache-refresh", CacheRefreshController)

import CampaignConfigurerController from "./campaign_configurer_controller"
application.register("campaign-configurer", CampaignConfigurerController)

import CampaignSequenceSortableController from "./campaign_sequence_sortable_controller"
application.register("campaign-sequence-sortable", CampaignSequenceSortableController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ContentTabsController from "./content_tabs_controller"
application.register("content-tabs", ContentTabsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatWidgetController from "./chat_widget_controller"
application.register("chat-widget", ChatWidgetController)

import CollapsibleFormController from "./collapsible_form_controller"
application.register("collapsible-form", CollapsibleFormController)

import ComboSelectController from "./combo_select_controller"
application.register("combo-select", ComboSelectController)

import ComposerFormController from "./composer_form_controller"
application.register("composer-form", ComposerFormController)

import ComposerToggleController from "./composer_toggle_controller"
application.register("composer-toggle", ComposerToggleController)

import CustomFieldSelectorController from "./custom_field_selector_controller"
application.register("custom-field-selector", CustomFieldSelectorController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import DeviceContactsController from "./device_contacts_controller"
application.register("device-contacts", DeviceContactsController)

import DripPreviewController from "./drip_preview_controller"
application.register("drip-preview", DripPreviewController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FrameLoaderController from "./frame_loader_controller"
application.register("frame-loader", FrameLoaderController)

import LaunchTimeController from "./launch_time_controller"
application.register("launch-time", LaunchTimeController)

import MailingFormController from "./mailing_form_controller"
application.register("mailing-form", MailingFormController)

import MembersQuickSearchController from "./members_quick_search_controller"
application.register("members-quick-search", MembersQuickSearchController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import NavTabsController from "./nav_tabs_controller"
application.register("nav-tabs", NavTabsController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NewsletterDateController from "./newsletter_date_controller"
application.register("newsletter-date", NewsletterDateController)

import NewsletterTimeController from "./newsletter_time_controller"
application.register("newsletter-time", NewsletterTimeController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PhoneNumbersController from "./phone_numbers_controller"
application.register("phone-numbers", PhoneNumbersController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PreviewRecipientController from "./preview_recipient_controller"
application.register("preview-recipient", PreviewRecipientController)

import PullToRefreshController from "./pull_to_refresh_controller"
application.register("pull-to-refresh", PullToRefreshController)

import QuickFilterController from "./quick_filter_controller"
application.register("quick-filter", QuickFilterController)

import RadioRevealController from "./radio_reveal_controller"
application.register("radio-reveal", RadioRevealController)

import RailsuiClipboardController from "./railsui_clipboard_controller"
application.register("railsui-clipboard", RailsuiClipboardController)

import RailsuiComboboxController from "./railsui_combobox_controller"
application.register("railsui-combobox", RailsuiComboboxController)

import RailsuiCountUpController from "./railsui_count_up_controller"
application.register("railsui-count-up", RailsuiCountUpController)

import RailsuiDateRangePickerController from "./railsui_date_range_picker_controller"
application.register("railsui-date-range-picker", RailsuiDateRangePickerController)

import RailsuiDropdownController from "./railsui_dropdown_controller"
application.register("railsui-dropdown", RailsuiDropdownController)

import RailsuiRangeController from "./railsui_range_controller"
application.register("railsui-range", RailsuiRangeController)

import RailsuiReadMoreController from "./railsui_read_more_controller"
application.register("railsui-read-more", RailsuiReadMoreController)

import RailsuiSelectAllController from "./railsui_select_all_controller"
application.register("railsui-select-all", RailsuiSelectAllController)

import RailsuiTabsController from "./railsui_tabs_controller"
application.register("railsui-tabs", RailsuiTabsController)

import RailsuiToastController from "./railsui_toast_controller"
application.register("railsui-toast", RailsuiToastController)

import RailsuiToggleController from "./railsui_toggle_controller"
application.register("railsui-toggle", RailsuiToggleController)

import RailsuiTooltipController from "./railsui_tooltip_controller"
application.register("railsui-tooltip", RailsuiTooltipController)

import RecommendationsController from "./recommendations_controller"
application.register("recommendations", RecommendationsController)

import SearchLoaderController from "./search_loader_controller"
application.register("search-loader", SearchLoaderController)

import SegmentLoaderController from "./segment_loader_controller"
application.register("segment-loader", SegmentLoaderController)

import SocialScheduleFormController from "./social_schedule_form_controller"
application.register("social-schedule-form", SocialScheduleFormController)

import SortableArticlesController from "./sortable_articles_controller"
application.register("sortable-articles", SortableArticlesController)

import SurveyFormController from "./survey_form_controller"
application.register("survey-form", SurveyFormController)

import SwipeCardController from "./swipe_card_controller"
application.register("swipe-card", SwipeCardController)

import SwipeController from "./swipe_controller"
application.register("swipe", SwipeController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaskStatusController from "./task_status_controller"
application.register("task-status", TaskStatusController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import UrlParamsController from "./url_params_controller"
application.register("url-params", UrlParamsController)

import VcardImportController from "./vcard_import_controller"
application.register("vcard-import", VcardImportController)

import VirtualScrollController from "./virtual_scroll_controller"
application.register("virtual-scroll", VirtualScrollController)
